import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  AfterContentChecked,
  AfterContentInit
} from '@angular/core'
import { FormGroup } from '@angular/forms'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs/Subject'
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-ae-summary-case-table',
  templateUrl: './ae-summary-case-table.component.html',
  styleUrls: ['./ae-summary-case-table.component.scss']
})
export class AeSummaryCaseTableComponent implements OnInit, AfterContentChecked {

  @Output() viewCasebyId = new EventEmitter()
  @ViewChild(DataTableDirective) dtElement: DataTableDirective
  @Input() companyProfile: any
  @Input() printPage
  @Input() exportFunctions: Map<String, Function>
  dtTriggerForcasebyAE: Subject<any> = new Subject()
  subscription: Subscription
  subscriptionSearch: Subscription
  form: FormGroup
  casebyAEDataTableOptions: DataTables.Settings = {}
  casebyAEDataTableOptionsConfig: DataTables.Settings = {}
  type
  initTableFirstTime = false
  listTable = []
  listHeader = []
  symbol
  constructor(private store: StoreService,
    private cpmService: CpmService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.listTable = []
    this.casebyAEDataTableOptions = {
      autoWidth: true,
      paging: false,
      searching: true,
      info: false,
      scrollY: '320px',
      scrollCollapse: true,
      order: [[7, 'desc']],
      language: {
        emptyTable: 'No information found'
      },
      columnDefs: [
        {
          type: 'stringMonthYear',
          targets: 7
        },
        {
          targets: 7,
          orderData: 8
        },
        {
          targets: 8,
          visible: false,
          searchable: false
        }
      ],
      destroy: true
    }

    this.casebyAEDataTableOptionsConfig = {
      autoWidth: false,
      paging: false,
      searching: false,
      info: false,
      // scrollY: '320px',
      order: [[7, 'desc']],
      language: {
        emptyTable: 'No information found'
      },
      columnDefs: [
        {
          type: 'stringMonthYear',
          targets: 7
        },
        {
          targets: 7,
          orderData: 8
        },
        {
          targets: 8,
          visible: false,
          searchable: false
        }
      ],
      destroy: true
    }
    this.onChangeData()
  }
  
  onChangeData() {
    this.type = 'owner'
    if (this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy()
      })
    }
    this.listTable = []
    this.symbol = ''
    this.cpmService.getCrmCase(this.symbol, this.type).then(success => {
      const listData = success
      listData.map(obj => {
        const list = {
          symbol: obj.securitySymbol,
          comName: obj.companyNameThai,
          owner: obj.caseOwner,
          meet: obj.meetingObjective,
          caseId: obj.caseId,
          status: obj.caseStatus,
          type: obj.type,
          date: obj.lastUpdateDate,
          id: obj.id
        }
        this.listTable.push(list)
      })

      if (!this.initTableFirstTime) {
        this.dtTriggerForcasebyAE.next()
        this.initTableFirstTime = true
      } else {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          this.dtTriggerForcasebyAE.next()
        })
      }

    })

    this.listHeader = [
      'Symbol',
      'Company name',
      'Case owner',
      'Case ID',
      'Case type',
      'Service objective',
      'Case status',
      'Update date',
      'Sort date'
    ]
  }

  ngAfterContentChecked() {
    let x = document.getElementsByClassName('dataTables_scrollBody');
    if (x[0]) {
      if (x[0].scrollHeight > x[0].clientHeight) document.getElementsByClassName('dataTables_scrollHeadInner')[0].classList.add("scrollHeadInner");
      else document.getElementsByClassName('dataTables_scrollHeadInner')[0].classList.add("noScrollHeadInner");
    }
  }


  getDataTableConfig() {
    if (!this.printPage) {
      return this.casebyAEDataTableOptions
    } else {
      return this.casebyAEDataTableOptionsConfig
    }
  }

  viewCase(id, symbol) {
    this.store.setOutputCaseByIdBehavior(id)
    this.store.setSearchInputBehavior(symbol)
    this.viewCasebyId.emit({ id: id, symbol: symbol })
  }
  rerender(): void {
    if (
      this.dtElement !== undefined &&
      this.dtElement.dtInstance !== undefined
    ) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy()
        this.dtTriggerForcasebyAE.next()
      })
    }
  }

  get ws_data_toExcel() {
    const ws_data = [];
    ws_data.push([...this.listHeader.slice(0, this.listHeader.length - 1)]);
    this.listTable.map(data => {
      ws_data.push([
        data.symbol,
        data.comName,
        data.owner,
        data.caseId,
        data.type,
        data.meet,
        data.status,
        this.datePipe.transform(data.date, 'd MMM yyyy')
      ]);

    })

    return ws_data
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/ae-summary-case-table/ae-summary-case-table.component.ts